import { Component } from '@angular/core';

@Component({
    selector: 'app-calendly',
    templateUrl: './calendly.component.html',
    standalone: false
})
export class CalendlyComponent {

}
